export function serviceRequest(state = {
    fetching:false,
    fetched: false,
    error:null,
},{
    type,
    payload
}){
    
    switch(type){
        case "CREATE_SERVICE_START":           
        case "FETCH_SERVICES_START":                                 
        case "UPDATE_SERVICE_START":                                 
            return {
                ...state, 
                fetching:true,
            }        
        case "CREATE_SERVICE_FULFILLED":           
        case "FETCH_SERVICES_FULFILLED":                                 
        case "UPDATE_SERVICE_FULFILLED":                                 
            return {
                ...state,
                fetching:false, 
                fetched:true, 
                error: null
            }    
        case "CREATE_SERVICE_ERROR":
        case "FETCH_SERVICES_ERROR":
        case "UPDATE_SERVICE_ERROR":
            return {
                ...state,
                fetching:false, 
                error:payload
            }
        default:
            return state;
    }
    
}